import { render, staticRenderFns } from "./serviceJobResolutions.vue?vue&type=template&id=b17bba88&"
import script from "./serviceJobResolutions.vue?vue&type=script&lang=ts&"
export * from "./serviceJobResolutions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports